module.exports = __webpack_public_path__ + "img/members-icon-dark.5600a66b.svg";